var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:rgb(17,24,39);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8525391,15.8505859v2.65625H4.3823233l0.0000005-2.65625c0-0.5522852-0.447715-1-0.9999995-1 s-0.9999995,0.4477148-0.9999995,1L2.3823242,20.506834h19.4702129v-4.6562481 c0-0.5522842-0.4477158-0.9999981-0.9999981-0.9999981c-0.5522842,0-0.9999981,0.4477139-0.9999981,0.9999981H19.8525391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1176758,15.9521484V7.4199219c0-0.5522852-0.4477158-1-1-1c-0.5522852,0-1,0.4477148-1,1v8.5322266 c0,0.5522842,0.4477148,1,1,1C12.66996,16.9521484,13.1176758,16.5044327,13.1176758,15.9521484"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7461691,11.412673l4.3715057-4.3715062l4.3715067,4.3715062 c0.3905239,0.3905239,1.0236893,0.3905249,1.4142132,0.000001c0.3905239-0.3905249,0.3905258-1.0236902,0.0000019-1.4142141 l-5.7857218-5.7857203L6.3319554,9.9984589c-0.3905249,0.3905239-0.3905253,1.0236893-0.0000005,1.4142141 c0.3905244,0.3905249,1.0236897,0.3905249,1.4142146,0.000001L7.7461691,11.412673z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.97d9f5e625abc73f24b95e2a4a41ebf6.svg";
export { ForwardRef as ReactComponent };